import { render, staticRenderFns } from "./PirateForm.vue?vue&type=template&id=7d52668d&"
import script from "./PirateForm.vue?vue&type=script&lang=js&"
export * from "./PirateForm.vue?vue&type=script&lang=js&"
import style0 from "./PirateForm.vue?vue&type=style&index=0&id=7d52668d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports